
import { defineComponent } from 'vue'
import { mapState, mapMutations } from 'vuex'
import { lookupGeos, lookupOffers, lookupTrafficSources } from '@/utils/lookups'

export default defineComponent({
  name: 'GeneralInfo',
  props: ['defaultOptions', 'disable'],
  computed: mapState('campaignsModule', ['campaign', 'errors']),
  data: function() {
    return {
      offers: [...(this.defaultOptions.offers || [])],
      trafficSources: [...(this.defaultOptions.trafficSources || [])],
      geos: [...(this.defaultOptions.geos || [])],
    }
  },
  methods: {
    ...mapMutations('campaignsModule', ['update']),
    async getOffers(value: string, update: any) {
      await lookupOffers(this, value, update, [this.campaign.offerId])
    },
    async getGeos(value: string, update: any) {
      await lookupGeos(this, value, update, true)
    },
    async getTrafficSources(value: string, update: any) {
      await lookupTrafficSources(this, value, update)
    },
  },
})
